import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { urlDocDpto, urlDocSector, urlT3 } from 'src/app/common';
import { Observable } from 'rxjs';
import { Tier3 } from 'src/app/models/obs/tier3';
import { SearchOption } from 'src/app/components/util/search/searchOption';

@Injectable({
  providedIn: 'root'
})
export class Tier3Service {

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get(`${urlT3}/get-all`);
  }

  getAllNationalAndSectorialTrends(idsector: string) {
    return this.http.get(`${urlT3}/get-all-tn-ts/${idsector}`);
  }

  getOne(id: number) {
    return this.http.get(`${urlT3}/get-one/${id}`);
  }

  get4code(id: string) {
    return this.http.get(`${urlT3}/get4code/${id}`);
  }

  get4codetest(id: string) {
    return this.http.get(`${urlT3}/get4code-test/${id}`);
  }

  getByIdTier1(id: number) {
    return this.http.get(`${urlT3}/get4t1/${id}`);
  }

  get4t1adm(id: string) {
    return this.http.get(`${urlT3}/get4t1adm/${id}`);
  }

  get4Event(id: number) {
    return this.http.get(`${urlT3}/get4Evt/${id}`);
  }

  getDptos() {
    return this.http.get(`${urlT3}/get-dptos`);
  }

  create(data: Tier3): Observable<Tier3> {
    return this.http.post(`${urlT3}/create`, data);
  }

  update(id: string, data: Tier3): Observable<Tier3> {
    return this.http.put(`${urlT3}/update/${id}`, data);
  }

  delete(id: string) {
    return this.http.delete(`${urlT3}/delete/${id}`);
  }

  getIdTier1(data: any) {
    return this.http.post(`${urlT3}/getidtier1`, data);
  }

  getTier3Description(data: any) {
    return this.http.get(`${urlT3}/gettier3description`, data);
  }

  getTier3MostView4SliderA(id: string) {
    return this.http.get(`${urlT3}/get-tier3-4sliderA/${id}`);
  }

  getTier3MostView4SliderB(id: string) {
    return this.http.get(`${urlT3}/get-tier3-4sliderB/${id}`);
  }

  getRTier3MostView4SliderA(id: string) {
    return this.http.get(`${urlT3}/get-Rtier3-4sliderA/${id}`);
  }

  getRTier3MostView4SliderB(id: string) {
    return this.http.get(`${urlT3}/get-Rtier3-4sliderB/${id}`);
  }

  addViewToTier3(id: string) {
    return this.http.get(`${urlT3}/add-visitTier3/${id}`);
  }

  getDptos4IdTier3(id: number) {
    return this.http.get(`${urlT3}/get-dptos-4idtier3/${id}`);
  }

  getSectorialReportBySector(idsector: string) {
    return this.http.get(`${urlDocSector}/getrepbysector/${idsector}`);
  }

  getTerritorialReportByDptoAndTier1(iddpto: string, idtier1: number) {//obtener reportes de observatorio
    return this.http.get(`${urlDocDpto}/getrepbydpto/${iddpto}/${idtier1}`);
  }

  getByYear(idTier1: string, year: string) {
    return this.http.get(`${urlT3}/get-by-year/${idTier1}/${year}`);
  }

  getAllByIdT14Admin(idtier1: string) {
    return this.http.get(`${urlT3}/get-allt3-by-idt1-4admin/${idtier1}`);
  }

  getRelatedT3By2Params(q: string, idEvenType: number): Observable<SearchOption[]> {
    return this.http.get<SearchOption[]>(`${urlT3}/search-t3-by-2param/${q}/${idEvenType}`);
  }

  getRelatedT3By3Params(q: string, idEvenType: number, idsector: number): Observable<SearchOption[]> {
    return this.http.get<SearchOption[]>(`${urlT3}/search-t3-by-3param/${q}/${idEvenType}/${idsector}`);
  }

  getRelatedContent(data: { idTier3: number; keywords: string }) {
    return this.http.post(`${urlT3}/get-related-tier3`, data);
  }

  cloneTier3(id: string) {
    return this.http.post(`${urlT3}/clone-tier3/${id}`, null);
  }

  setApprovedVersion(data: { idold: number; idnew: number, reviewedBy: string }) {
    return this.http.post(`${urlT3}/set-approved-version`, data);
  }

  deleteT3Casc(id: string) {
    return this.http.delete(`${urlT3}/delete-tier3-cascade/${id}`);
  }

  validateCode(code: string) {
    return this.http.post(`${urlT3}/validate-code`, { code });
  }

  idT3blocked(id: number) {
    return this.http.get(`${urlT3}/is-t3-blocked/${id}`);
  }

  idSectionblocked(id: number) {
    return this.http.get(`${urlT3}/is-section-blocked/${id}`);
  }

  setInactiveVersion(id: number) {
    return this.http.get(`${urlT3}/set-inactive-version/${id}`);
  }
  
}
